@if (isLoading > 0 || overview.length > 0) {
  <birdz-card
    class="overview-card"
    [isLoading]="isLoading > 0"
    [isEmpty]="(hasPerimeter$ | async) !== true || kpis.length === 0"
  >
    <div card-title>
      {{ 'TAB_KPI_SUMMARY' | transloco }}
    </div>
    <div card-corner>
      @if ((hasPerimeter$ | async) === true && kpis.length > 0) {
        <button
          class="corner-help-button bdz-mat-icon-button-info"
          matIconButton
          (click)="openContractKpiHelp()"
          [matTooltip]="'CONTRACT_CONFIG_HELP.TITLE' | transloco"
        >
          <mat-icon>question_mark</mat-icon>
        </button>
      }
    </div>
    <div card-empty>
      @if ((hasPerimeter$ | async) === true && kpis.length === 0) {
        {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_1' | transloco }}<br />
        {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_2' | transloco }}
      } @else {
        {{ 'PLEASE_SELECT_A_CONTRACT' | transloco }}
      }
    </div>
    <div card-body>
      <div class="fixed-overview">
        @if (indicatorsDate) {
          <div class="date-indicator">
            {{ 'DAILY_INDICATORS' | transloco }} {{ 'DATE_AT' | transloco | lowercase }}
            {{ indicatorsDate | formatDate }}
            @if (isBirdzAdmin() && overviewLastModified) {
              <span class="birdz-admin">({{ overviewLastModified | formatDatetimeTimezone }})</span>
            }
          </div>
        }
        @let techno = techno$ | async;
        @let technoExtraKpis = extraKpis[techno ?? ''] ?? [];
        @for (kpi of kpis; track kpi) {
          @let item = getOverviewItem(kpi.id);
          @if (item) {
            @let kpiLabel = this.getKpiLabel(kpi);
            <div class="kpi" [class]="{ 'birdz-admin': kpi.admin_birdz_display }">
              <div class="label">
                <span [class]="{ small: kpiLabel.length > 30 }">
                  {{ kpiLabel }}
                </span>
              </div>
              <div class="value">
                @if (kpi.type !== 'NB_JOURS') {
                  @let deviation = getDeviation(item?.value ?? null, kpi.threshold);
                  <span>{{ item?.value !== null ? (item?.value | formatNumber: '1.2-2') + '%' : '-' }}</span>
                  @if (deviation !== null) {
                    <span
                      [style]="{ color: deviation.color }"
                      [matTooltip]="'DEVIATION_FROM_KPI_THRESHOLD' | transloco"
                    >
                      ({{ deviation.sign + (deviation.value | formatNumber: '1.0-1') + '%' }})
                    </span>
                  }
                } @else {
                  <span>
                    {{
                      item?.value !== null
                        ? (item?.value | formatNumber: '1.0-0') + ' ' + ('DAY_S' | transloco | lowercase)
                        : '-'
                    }}
                  </span>
                }
              </div>
            </div>

            <!-- Extra values synced with the KPI -->
            @for (extraKpi of technoExtraKpis; track extraKpi) {
              @if (item.extra && item.extra[extraKpi]) {
                <div class="kpi" [class]="{ 'birdz-admin': kpi.admin_birdz_display }">
                  @let extraKpiLabel = `EXTRA_KPI.${techno?.toUpperCase()}.${extraKpi.toUpperCase()}` | transloco;
                  <div class="label">
                    <span [class]="{ small: extraKpiLabel.length > 30 }">{{ extraKpiLabel }}</span>
                  </div>
                  <div class="value">{{ item.extra[extraKpi] }}</div>
                </div>
              }
            }
          }
        }
      </div>
    </div>
  </birdz-card>
}
<birdz-card [isLoading]="isLoading > 0" [isEmpty]="(hasPerimeter$ | async) !== true || kpis.length === 0">
  <div card-title>
    {{
      ((techno$ | async) === 'watermetering'
        ? 'HISTORICIZED_RATE_OF_INDEX_REPORTING'
        : 'HISTORICIZED_RATE_OF_DATA_REPORTING'
      ) | transloco
    }}
    @if ((techno$ | async) === 'watermetering') {
      <button
        matIconButton
        class="help-button bdz-mat-icon-button-info-variant"
        [matTooltip]="'HELP' | transloco"
        (click)="openChartHelp()"
      >
        <mat-icon>help</mat-icon>
      </button>
    }
  </div>
  <div card-subtitle>
    <birdz-period-display></birdz-period-display>
  </div>
  <div card-corner>
    @if ((hasPerimeter$ | async) && kpis.length > 0 && isLoading <= 0) {
      <button
        class="corner-help-button bdz-mat-icon-button-primary"
        matIconButton
        (click)="export()"
        [matTooltip]="'EXPORT_CHART_CONTENT' | transloco"
      >
        <mat-icon>download_2</mat-icon>
      </button>
    }
  </div>
  <div card-empty>
    @if ((hasPerimeter$ | async) === true && kpis.length === 0) {
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_1' | transloco }}<br />
      {{ 'MISSING_KPI_CONFIG_FOR_CONTRACT_PART_2' | transloco }}
    } @else {
      {{ 'PLEASE_SELECT_A_CONTRACT' | transloco }}
    }
  </div>
  <div card-body>
    <div class="dynamic-investigation">
      <div class="controls">
        <!-- time navigation -->
        <birdz-period-prev-next>
          <birdz-period-picker
            [preserveGranularity]="true"
            [granularities]="snapToValues"
            [disabledGranularities]="disabledSnapToValues"
            [shortcuts]="shortcuts"
            [disabledShortcuts]="disabledShortcuts"
          ></birdz-period-picker>
        </birdz-period-prev-next>

        <!-- kpis -->
        <mat-form-field>
          <mat-label>{{ 'KPIS' | transloco }}</mat-label>
          <mat-select #kpiSelect multiple="true" [(ngModel)]="selectedKpis" (ngModelChange)="onKpiSelectionChanged()">
            <!-- search bar -->
            <birdz-select-search-bar [options]="kpis" [searchFunction]="kpiSearchFunction" #kpiSearch>
            </birdz-select-search-bar>

            @for (kpi of kpis | filter: kpiSearch.filter; track kpi) {
              <mat-option
                [value]="kpi.id"
                (onSelectionChange)="kpiSearch.onMultipleSelectSelectionChange($event, kpiSelect)"
                [class]="{ 'birdz-admin': kpi.admin_birdz_display }"
              >
                {{ this.getKpiLabel(kpi, true) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- save the current kpi selection as a favorite -->
        <app-kpi-favorite-save></app-kpi-favorite-save>

        <birdz-period-granularity-mode
          [options]="granularities"
          [disabledOptions]="disabledGranularities"
        ></birdz-period-granularity-mode>
      </div>

      @if (undisplayableSelectedKpisMessage) {
        <birdz-alert type="warning" icon="warning">
          {{ undisplayableSelectedKpisMessage }}
        </birdz-alert>
      }

      <!-- chart -->
      <div class="wrapper">
        @if (!isLoading && !isLoadingKpiRates) {
          @if (chartOptions) {
            <div class="chart-controls">
              @if ((techno$ | async) === 'watermetering') {
                <mat-slide-toggle [checked]="autoscale" (change)="toggleAutoscale($event)">
                  {{ 'AUTOSCALE' | transloco }}
                </mat-slide-toggle>
              }

              <!-- apply a saved kpi selection -->
              <app-kpi-favorites-menu></app-kpi-favorites-menu>
            </div>

            <highcharts-chart
              (chartInstance)="setChart($event)"
              [(update)]="updateFlag"
              class="chart"
              [options]="chartOptions"
              [oneToOne]="true"
            ></highcharts-chart>
          } @else {
            <div class="placeholder">
              @if (isHourlyPeriodTooLong) {
                {{ 'PLEASE_CHOOSE_A_SHORTER_PERIOD_HOURLY' | transloco: { max: hourlyMaxDays } }}
              } @else {
                {{ 'PLEASE_CHOOSE_A_SHORTER_PERIOD' | transloco }}
              }
            </div>
          }
        } @else {
          <div class="loader">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
      </div>
    </div>
  </div>
</birdz-card>
